export const BRAND = {
  name: "Buggu Capital",
  tagline: "Invest • Grow • Succeed",
  founder: "Chandan Kumar Sah",
  // Colored logo (light-mode)
  logoLight:
    "https://i.postimg.cc/hhWG3RR8/buggudark-logo.png",
  // White/monochrome logo (dark-mode)
  logoDark:
    "https://i.postimg.cc/XvVrbWB4/bullog-ligh-capital.png",
  // Bull vs Bear – theme aware (new uploaded image used for both)
  bullBearLight:
    "https://customer-assets.emergentagent.com/job_stock-trading-hub-10/artifacts/8ywequsu_ChatGPT%20Image%20Jul%202%2C%202026%2C%2012_01_44%20AM.png",
  bullBearDark:
    "https://customer-assets.emergentagent.com/job_stock-trading-hub-10/artifacts/8ywequsu_ChatGPT%20Image%20Jul%202%2C%202026%2C%2012_01_44%20AM.png",
  socials: {
    youtube: "https://www.youtube.com/@buggucapital",
    instagram: "https://www.instagram.com/buggucapital",
    telegram: "https://t.me/+ldoOmjZrFRk4NzY9",
  },
  agency: {
    name: "Nodewap Technology Pvt. Ltd",
    url: "https://nodewap.com",
  },
};

export const NAV_ITEMS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Topics", href: "#topics" },
  { label: "Videos", href: "#videos" },
  { label: "Connect", href: "#connect" },
  { label: "Contact", href: "#contact" },
];
